window.voyadoApi = window.legendsVoyado.elevate({
  clusterId: 'w2CE3B25E',
  market: 'CFP',
  locale: 'en-US',
  touchpoint: window.innerWidth > 768 ? 'desktop' : 'mobile',
  session: window.legendsVoyado.localStorageBackedSession(),
});

class VoyadoProductCard extends HTMLElement {
  constructor(productData) {
    super();
    this.productData = productData;
    this.noNotification = this.getAttribute('no-notification') || false;
  }

  connectedCallback() {
    if (this.noNotification) return;
    this.buildProductCard();
    this.addNotificationOnClick();
  }

  buildProductCard() {
    const thumbnail = this.productData?.imageInfo?.images[0];
    const secondaryImage = this.productData?.imageInfo?.images[1];
    const renderPrice = (productData) => {
      const price =
        productData?.listPrice?.min > productData?.sellingPrice?.min
          ? `<p class="voyado-product-card__price"><span class="price-list">$${productData?.listPrice?.min}</span><span class="price-sale">$${productData?.sellingPrice?.min}</span></p>`
          : `<p class="voyado-product-card__price">$${productData?.sellingPrice?.min}</p>`;
      return price;
    };
    this.innerHTML = `
          <a class="voyado-product-card__link" href="${this.productData?.link}">
              <div class="voyado-product-card__image-wrapper">
                  <img src="${thumbnail?.sources[0]?.url}" alt="${
                    thumbnail?.alt
                  }" loading="lazy">
                  ${
                    secondaryImage
                      ? `
                    <img src="${secondaryImage?.sources[0]?.url}" alt="${secondaryImage?.alt}" loading="lazy">
                  `
                      : ''
                  }
              </div>
              <div>
                  <p class="voyado-product-card__title">${
                    this.productData?.title
                  }</p>
              </div>
              <div class="voyado-product-card__price-wrapper">
                  ${renderPrice(this.productData)}
              </div>
          </a>
      `;
  }

  addNotificationOnClick() {
    const cardLink = this.querySelector('a');
    cardLink.addEventListener('click', (e) => {
      e.preventDefault();

      const ticket = this.productData?.ticket;
      if (ticket) {
        window.voyadoApi.notify.click(ticket).finally(() => {
            window.location.href = `${this.productData?.link}`;
          });
      }
    });
  }
}

class VoyadoProductGrid extends HTMLElement {
  constructor() {
    super();
    this.pageReference = null;
    this.limit = 24;
    this.skip = 0;
    this.sort = 'RELEVANCE';
    this.facets = {};
    this.priceRange = {};
  }

  async connectedCallback() {
    this.pageReference = this.getAttribute('page-reference') || '';
    if (this.pageReference === '') {
      console.error('voyado: page reference is required');
      return;
    }
    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    const data = await this.getGridData({}, {}, true);

    this.buildVoyadoSection(data);
  }

  async getGridData(customParams = {}, customBody = {}, resetSkip = true) {
    const params = {
      pageReference: this.pageReference,
      limit: this.limit,
      skip: this.skip,
      ...customParams,
    };
    const body = {
      primaryList: {
        include: true,
      },
      ...customBody,
    };

    const response = await window.voyadoApi.query.landingPage(params, body);

    if (resetSkip) {
      this.skip = 0;
    }
    this.skip += response.primaryList.productGroups.length;

    return response;
  }

  buildProductGrid(data) {
    const productGroups = data.primaryList.productGroups;
    const productGrid = this.querySelector('.voyado-collection__product-grid');
    productGrid.innerHTML = '';
    productGroups.forEach((productGroup) => {
      const voyadoProductCard = this.initProductCard(productGroup);
      productGrid.appendChild(voyadoProductCard);
    });

    if (data.primaryList.totalHits === 0) {
      productGrid.innerHTML =
        '<div class="voyado-collection__no-results">No results found</div>';
    }

    return productGrid;
  }

  buildNoResultsSlider(data) {
    const slider = document.createElement('div');
    slider.innerHTML = `
    <voyado-slider page-reference="/" limit="16">
      <h2 class="voyado-slider__title">
        Top Products
      </h2>
              <div class="voyado-slider__container"></div>
    </voyado-slider>
    `;
    return slider;
  }

  updateProductCardAriaLabels() {
    const productCards = document.querySelectorAll('voyado-product-card');

    productCards.forEach((productCard, index) => {
      productCard.setAttribute(
        'aria-label',
        `Product ${index + 1} of ${productCards.length}`,
      );
    });
  }

  initProductCard(productGroup) {
    const voyadoProductCard = document.createElement('voyado-product-card');
    voyadoProductCard.productData = productGroup.products[0];
    return voyadoProductCard;
  }

  buildVoyadoSection(data) {
    const voyadoSection = this.querySelector('.voyado-collection__wrapper');
    const voyadoLoadMoreContent = this.buildLoadMoreButton(data);
    const mobileFilter = this.buildMobileFilter(data);

    if (data.primaryList.totalHits > 0) {
      //voyadoSection.appendChild(this.buildDidYouMean(data));
      voyadoSection.appendChild(mobileFilter);
      voyadoSection.appendChild(this.buildProductGrid(data));
      voyadoSection.appendChild(voyadoLoadMoreContent);
      this.buildfilterDrawer(data);
    } else {
      const noResultsFilter = this.querySelector(
        '.voyado-collection__mobile-filter',
      );
      noResultsFilter.innerHTML = '';
      voyadoSection.appendChild(this.buildProductGrid(data));
      voyadoSection.appendChild(this.buildNoResultsSlider(data));
    }

    this.appendChild(voyadoSection);
    this.updateProductCardAriaLabels();
    this.updateSEOTitle(data);
  }

  buildDidYouMean(data) {
    const didYouMean = data.didYouMean;
    const didYouMeanContainer = document.createElement('div');
    didYouMeanContainer.className = 'voyado-collection__did-you-mean';
    const didYouMeanItem = (suggestion) => {
      return `
      <a href="/search?q=${suggestion.q}">${suggestion.q}</a>
      `;
    };
    didYouMean.forEach((suggestion) => {
      didYouMeanContainer.appendChild(didYouMeanItem(suggestion));
    });
    return didYouMeanContainer;
  }

  updateSEOTitle(data) {
    document.title = `${data.primaryList?.totalHits} Results found for "${this.query}" - ${window.shopName}`;
  }

  resultCount(data) {
    const resultCount = `<div class="voyado-collection__result-count">Showing 1 - ${this.skip} of ${data.primaryList?.totalHits}</div>`;
    return resultCount;
  }

  buildMobileFilter(data) {
    const mobileFilterContainer = this.querySelector(
      '.voyado-collection__mobile-filter',
    );
    mobileFilterContainer.innerHTML = `
    <div class="voyado-collection__mobile-filter-wrap">
      <div class="voyado-collection__mobile-filter-item">
        <button class="voyado-collection__mobile-filter-button">
          <span>Filter and sort</span>
        </button>
      </div>
      <div class="voyado-collection__result-count-wrap">
            ${this.resultCount(data)}
      </div>
      <div class="voyado-collection__desktop-filter-sort-wrap">
       ${this.buildFilterSort(data, 'desktop-filter-sort')}
      </div>
    </div>
    `;

    const mobileFilterButton = mobileFilterContainer.querySelector(
      '.voyado-collection__mobile-filter-button',
    );
    mobileFilterButton.addEventListener('click', (e) => {
      e.preventDefault();
      const filterDrawer = document.querySelector(
        '.voyado-collection__filter-drawer',
      );
      filterDrawer.classList.add('open');
    });
    return mobileFilterContainer;
  }

  buildfilterDrawer(data) {
    const filterDrawer = document.createElement('aside');
    filterDrawer.className = 'voyado-collection__filter-drawer';
    filterDrawer.innerHTML = `
    <div class="voyado-collection__filter-drawer-content">
      <div class="voyado-collection__filter-drawer-header">
        <p class="voyado-collection__filter-drawer-title">Filter and sort</p>
        <button class="voyado-collection__filter-drawer-close">
          <span class="sr-only">Close</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 5L5 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 5L19 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="voyado-collection__filter-drawer-body">
        <div class="voyado-collection__filter-drawer-sort-wrap">
          ${this.buildFilterSort(data, 'mobile-drawer-sort')}
        </div>
        ${this.buildFilterFacets(data)}
      </div>

      <div class="voyado-collection__filter-drawer-footer">
        <button class="voyado-collection__filter-drawer-clear-all">
          <span>Clear All</span>
        </button>
        <button class="voyado-collection__filter-drawer-apply">
          <span>See Results</span>
        </button>
      </div>
    </div>
    `;
    document.body.appendChild(filterDrawer);

    const closeButton = filterDrawer.querySelector(
      '.voyado-collection__filter-drawer-close',
    );
    //event listener to close the filter drawer
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeButton
        .closest('.voyado-collection__filter-drawer')
        .classList.remove('open');
    });

    //when clicking the aside we close the filter, does not work on child element click
    filterDrawer.addEventListener('click', (e) => {
      if (e.target.closest('.voyado-collection__filter-drawer-content')) return;
      e.preventDefault();
      this.closeFilterDrawer();
    });

    const clearAllButton = filterDrawer.querySelector(
      '.voyado-collection__filter-drawer-clear-all',
    );
    clearAllButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeFilterDrawer();
    });

    const applyButton = filterDrawer.querySelector(
      '.voyado-collection__filter-drawer-apply',
    );
    applyButton.addEventListener('click', (e) => {
      e.preventDefault();

      const sortValue = document.querySelector('#mobile-drawer-sort')?.value;
      const facetValues = filterDrawer.querySelectorAll(
        'input:not([type="range"]):checked',
      );
      const facetRanges = filterDrawer.querySelectorAll('input[type="range"]');

      this.closeFilterDrawer();
      this.UpdateDataWithFiltersAndSort(sortValue, facetValues, facetRanges);
    });
  }

  async UpdateDataWithFiltersAndSort(sortValue, facetValues, facetRanges) {
    const facetValuesArray = Array.from(facetValues);
    const facetValuesObject = {};
    facetValuesArray.forEach((input) => {
      const key = `f.${input.dataset.facetId}`;
      const value = facetValuesObject[key]
        ? `${facetValuesObject[key]}|${input.value}`
        : `${input.value}`;
      facetValuesObject[key] = value;
    });

    this.facets = { ...facetValuesObject };
    this.sort = sortValue;
    this.skip = 0; // reset the skip to 0 to get the first page of results

    const params = {
      //facetRanges: facetRanges,
      sort: this.sort,
      ...this.facets,
      skip: this.skip,
    };
    const body = {
      primaryList: {
        include: true,
      },
    };

    try {
      const data = await this.getGridData(params, body, true);
      this.replaceSectionWithData(data);
    } catch (error) {
      console.error(' voyado: error updating data with filters and sort', error);
    }
  }

  closeFilterDrawer() {
    const filterDrawer = document.querySelector(
      '.voyado-collection__filter-drawer',
    );
    filterDrawer.classList.remove('open');
  }

  buildFilterFacets(data) {
    const filterFacetsContainer = () => {
      return data?.primaryList?.facets
        .map((facet) => {
          if (facet.type === 'RANGE') {
            return '';
          }

          return `
          <div class="voyado-collection__filter-facet-wrap">
          <voyado-accordion>
            <div class="voyado-accordion__head">
              <button class="voyado-collection__filter-facet-label">
                ${facet.label}
                <span>
                ${this.chevronIcon()}
                </span>
              </button>
            </div>
            <div class="voyado-accordion__body">
              <div class="voyado-collection__filter-facet-values">
                ${
                  facet.type === 'TEXT'
                    ? textFacetValues(facet)
                    : facet.type === 'RANGE'
                      ? // ? rangeFacetValues(facet)
                        ''
                      : facet.type === 'COLOR'
                        ? colorFacetValues(facet)
                        : facet.type === 'SIZE'
                          ? sizeFacetValues(facet)
                          : ''
                }
              </div>
            </div>
          </voyado-accordion>
          </div>
        `;
        })
        .join('');
    };

    const textFacetValues = (facet) => {
      return facet.values
        .map((value) => {
          return `
          <div>
            <input data-facet-id="${facet.id}" data-value-id="${value.id}" id="${facet.id}-${value.id}" type="checkbox" class="voyado-collection__filter-facet-value-input" value="${value.id}">
            <label for="${facet.id}-${value.id}" class="voyado-collection__filter-facet-value-label">${value.label} (${value.count})</label>
          </div>
        `;
        })
        .join('');
    };

    const rangeFacetValues = (facet) => {
      return `
          <div>
            <input data-facet-id="${facet.id}" id="${facet.id}-range" type="range" class="voyado-collection__filter-facet-value-input" min="${facet.min}" max="${facet.max}">
            <label for="${facet.id}-range" class="voyado-collection__filter-facet-facet-label">${facet.label} ${facet.min} - ${facet.max}</label>
          </div>
        `;
    };

    const colorFacetValues = (facet) => {
      return facet.values
        .map((value) => {
          return `
          <div>
            <input data-facet-id="${facet.id}" id="${facet.id}-${value.id}" type="checkbox" class="voyado-collection__filter-facet-value-input" value="${value.id}">
            <label for="${facet.id}-${value.id}" class="voyado-collection__filter-facet-value-label">${value.label} (${value.count})</label>
          </div>
        `;
        })
        .join('');
    };

    const sizeFacetValues = (facet) => {
      return facet.sizeTypes[0].formats[0].values
        .map((value) => {
          return `
          <div>
            <input data-facet-id="${facet.id}" id="${facet.id}-${value.id}" type="checkbox" class="voyado-collection__filter-facet-value-input" value="${value.id}">
            <label for="${facet.id}-${value.id}" class="voyado-collection__filter-facet-value-label">${value.label} (${value.count})</label>
          </div>
        `;
        })
        .join('');
    };

    return filterFacetsContainer();
  }

  buildFilterSort(data, sortId) {
    const selectedSort = data.primaryList?.sort?.selected;
    const filterSortContainer = (data, sortId) => {
      return `
    <div class="voyado-collection__filter-sort-wrap">
    <label class="voyado-collection__filter-sort-label" for="${sortId}">Sort by</label>
    <select class="voyado-collection__filter-sort-select" id="${sortId}" value="${selectedSort}">
      ${data?.primaryList?.sort?.options
        .map(
          (option) => `
        <option value="${option.id}" ${
          option.id === selectedSort ? 'selected' : ''
        }>${option.label}</option>
      `,
        )
        .join('')}
    </select>
    </div>
    `;
    };

    return filterSortContainer(data, sortId);
  }

  buildLoadMoreButton(data) {
    const loadMoreWrapper = document.createElement('div');
    if (this.skip >= data.primaryList.totalHits) return loadMoreWrapper;
    loadMoreWrapper.className = 'voyado-collection__load-more-content';
    const loadMoreContent = (isLoading = false) => `
    <div class="voyado-collection__load-more-wrap">
      <a class="voyado-collection__load-more-button" href="${
        this.pageReference
      }?page=${this.skip / this.limit + 1}">
        ${isLoading ? '<span>Loading...</span>' : '<span>Load More</span>'}
      </a>
      ${this.resultCount(data)}
    </div>
  `;
    loadMoreWrapper.innerHTML = loadMoreContent();

    const loadMoreButton = loadMoreWrapper.querySelector(
      '.voyado-collection__load-more-button',
    );
    loadMoreButton.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        loadMoreButton.innerHTML = '<span>Loading...</span>';
        await this.loadMoreData(loadMoreButton);
        loadMoreButton.innerHTML = '<span>Load More</span>';
      } catch (error) {
        loadMoreButton.innerHTML = '<span>Load More</span>';
        console.error(' voyado: error loading more data', error);
      }
    });

    return loadMoreWrapper;
  }

  replaceLoadMoreButton(data) {
    const loadMoreWrapper = this.querySelector(
      '.voyado-collection__load-more-content',
    );
    const collectionGrid = this.querySelector('.voyado-collection__wrapper');
    if (loadMoreWrapper) {
      loadMoreWrapper.remove();
    }

    collectionGrid.appendChild(this.buildLoadMoreButton(data));
  }

  chevronIcon() {
    return `
    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="black">
      </path>
    </svg>
    `;
  }

  async loadMoreData(loadMoreButton) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const page = Number(urlParams.get('page')) || 1;
      const newPage = page + 1;
      const newParams = {
        skip: this.skip,
        sort: this.sort,
        ...this.facets,
      };
      const data = await this.getGridData(newParams, {}, false);
      // update page param to match data
      urlParams.set('page', newPage);
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;

      window.history.pushState({ path: newUrl }, '', newUrl);
      this.refreshSectionWithData(data);
      if (this.skip >= data.primaryList.totalHits) {
        loadMoreButton.remove();
        return;
      }
      //updating the href for search engine crawling
      urlParams.set('page', newPage + 1);
      loadMoreButton.href = `${
        window.location.pathname
      }?${urlParams.toString()}`;
    } catch (error) {
      console.error(' voyado: error loading more data', error);
    }
  }

  refreshSectionWithData(data) {
    this.refreshProductGrid(data);
    this.refreshResultsCount(data);
  }

  replaceSectionWithData(data) {
    this.refreshProductGrid(data, true);
    this.replaceLoadMoreButton(data);
    this.refreshResultsCount(data);
  }

  refreshProductGrid(data, replace = false) {
    const productGrid = document.querySelector(
      '.voyado-collection__product-grid',
    );
    const newProductData = data.primaryList.productGroups;

    if (replace) {
      productGrid.innerHTML = '';
    }

    newProductData.forEach((productGroup) => {
      const voyadoProductCard = this.initProductCard(productGroup);
      productGrid.appendChild(voyadoProductCard);
    });

    this.updateProductCardAriaLabels();
  }

  refreshResultsCount(data) {
    const resultsCount = document.querySelectorAll(
      '.voyado-collection__result-count',
    );
    resultsCount.forEach((resultCount) => {
      resultCount.innerHTML = `Showing 1 - ${this.skip} of ${data.primaryList?.totalHits}`;
    });
  }
}

class VoyadoAccordion extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.querySelector(
      'button.voyado-collection__filter-facet-label',
    ).addEventListener('click', (e) => {
      e.preventDefault();
      this.classList.toggle('open');
    });
  }
}

class VoyadoSearch extends VoyadoProductGrid {
  constructor() {
    super();
    this.query = null;
    this.pageReference = '/search';
    this.origin = 'ORGANIC';
  }
  async connectedCallback() {
    const query = this.getAttribute('query');
    this.query = query;

    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    const data = await this.getGridData({}, {}, true);

    this.buildVoyadoSection(data);
  }

  async getGridData(customParams = {}, customBody = {}, resetSkip = true) {
    //check if origin is in the url
    this.origin =
      new URLSearchParams(window.location.search).get('origin') || 'ORGANIC';

    const params = {
      limit: this.limit,
      skip: this.skip,
      q: this.query,
      origin: this.origin,
      ...customParams,
    };
    const body = {
      primaryList: {
        include: true,
      },
      secondaryList: {
        include: true,
      },
      ...customBody,
    };

    const response = await window.voyadoApi.query.searchPage(params, body);
    //remove origin from url
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('origin');
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    if (resetSkip) {
      this.skip = 0;
    }
    this.skip += response.primaryList.productGroups.length;

    return response;
  }

  buildVoyadoSection(data) {
    const searchTitle = document.querySelector('.voyado-search__title');

    super.buildVoyadoSection(data);
    this.buildSecondarySearchContent(data);

    if (data?.autoCorrect?.originalTotalHits === 0) {
      this.query = data?.autoCorrect?.q;
      searchTitle.innerHTML = `No Results for "${data.q}". Did you mean "${data?.autoCorrect?.q}"?`;
    } else {
      searchTitle.innerHTML = `Search Results for "${data.q}"`;
    }
  }

  buildSecondarySearchContent(data) {
    const productGroups = data?.secondaryList?.productGroups;
    if (!productGroups || productGroups.length === 0) return;

    const secondarySearchContent = document.createElement('div');
    secondarySearchContent.className = 'voyado-secondary-search-content';
    secondarySearchContent.innerHTML = `
    <h2 class="voyado-secondary-search-content__title">You Might Also Like</h2>
    <div class="voyado-slider__container"></div>
    `;
    const sliderContainer = secondarySearchContent.querySelector(
      '.voyado-secondary-search-content .voyado-slider__container',
    );
    const slider = document.createElement('div');
    slider.className = 'voyado-slider swiper';
    slider.innerHTML = `
      <div class="swiper-wrapper">
      </div>
      <div class="voyado-slider__controls">
        <div class="swiper-button-prev" aria-label="Previous slide"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next" aria-label="Next slide"></div>
      </div>
      `;
    const wrapper = slider.querySelector('.swiper-wrapper');

    productGroups.forEach((productGroup) => {
      const primaryProduct = productGroup.products[0];
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(new VoyadoProductCard(primaryProduct));
      wrapper.appendChild(slide);
    });

    sliderContainer.appendChild(slider);

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
      },
    });

    this.appendChild(secondarySearchContent);
  }
}

class VoyadoPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.limit = 4;
    this.skip = 0;
    this.query = '';
    this.emptySearchData = []; //the data returned when the search is empty
  }
  connectedCallback() {
    this.initPredictiveSearch();
  }

  initPredictiveSearch() {
    const input = this.querySelector('input.voyado-predictive-search__input');
    const results = this.querySelector('.voyado-predictive-search__results');
    const suggestedSearchContainer = this.querySelector(
      '.voyado-predictive-search__suggested-search',
    );

    // Create debounced search function ONCE
    const debouncedSearch = debounce(async (value) => {
      try {
        const data = await this.getSearchResults({ q: value });
        results.innerHTML = '';
        results.appendChild(this.buildSearchResults(data));
      } catch (error) {
        results.innerHTML = 'Error getting search results';
        console.error(' voyado: error getting search results', error);
        setTimeout(() => {
          results.innerHTML = '';
        }, 2000);
      }
    }, 200);

    const search = (e) => {
      this.query = e.target.value;
      if (e.target.value.length < 2) {
        results.classList.remove('open');
        suggestedSearchContainer.classList.add('open');
        return;
      }
      if (!results.classList.contains('open')) {
        results.classList.add('open');
        suggestedSearchContainer.classList.remove('open');
      }
      results.innerHTML = 'loading...';
      //debounce 200ms
      debouncedSearch(e.target.value);
    };

    input.addEventListener('keyup', async (e) => {
      if (e.key !== 'Escape') {
        search(e);
      }
    });

    input.addEventListener('keydown', async (e) => {
      if (e.key === 'Enter') {
        window.location.href = `/search?q=${e.target.value}&origin=ORGANIC`;
      }

      if (e.key === 'Escape') {
        results.classList.remove('open');
        suggestedSearchContainer.classList.remove('open');
      }
    });

    input.addEventListener('focus', () => {
      if (this.query.length < 2) {
        suggestedSearchContainer.classList.add('open');
        results.classList.remove('open');
        return;
      }
      results.classList.add('open');
      suggestedSearchContainer.classList.remove('open');
    });

    // Close when clicking OUTSIDE (instead of on blur)
    document.addEventListener('click', (e) => {
      const isInsideSearchResults = e.target.closest(
        'voyado-predictive-search',
      );
      if (!isInsideSearchResults) {
        results.classList.remove('open');
        suggestedSearchContainer.classList.remove('open');
      }
    });

    const initSuggestedSearch = async () => {
      try {
        await getSuggestedSearch();
        buildSuggestedSearch();
      } catch (error) {
        console.error(' voyado: error initializing suggested search', error);
      }
    };

    const getSuggestedSearch = async () => {
      this.emptySearchData = await this.getSearchResults({ q: '' });

    };

    const buildSuggestedSearch = () => {
      const phraseSuggestions = this.emptySearchData?.phraseSuggestions;
      const recentSearches = this.emptySearchData?.recentSearches;

      suggestedSearchContainer.innerHTML = `
          ${
            phraseSuggestions.length > 0
              ? `
                <div>
                  <p class="voyado-predictive-search__results-title">Suggestions</p>
                  <div class="voyado-predictive-search__results-suggestions">
                  ${phraseSuggestions
                    .map((search) => {
                      const highlightedContent = search.highlighted
                        .replace('{', '<strong>')
                        .replace('}', '</strong>');
                      return `
                    <a href="/search?q=${search.q}&origin=PHRASE_SUGGEST">${highlightedContent}</a>
                    `;
                    })
                    .join('')}
                  </div>
                </div>
                `
              : ''
          }
          ${
            recentSearches.length > 0
              ? `
                <div>
                  <p class="voyado-predictive-search__results-title">Recent Searches</p>
                  <div class="voyado-predictive-search__results-suggestions">
                  ${recentSearches
                    .map((search) => {
                      return `
                    <a href="/search?q=${search.q}&origin=RECENT_SEARCH">${search.q}</a>
                    `;
                    })
                    .join('')}
                  </div>
                </div>
                `
              : ''
          }
      `;
      return suggestedSearchContainer;
    };

    initSuggestedSearch();
  }

  async getSearchResults(customParams = {}, customBody = {}) {
    const params = {
      limit: this.limit,
      skip: this.skip,
      notify: true,
      ...customParams,
    };
    const body = {
      primaryList: {
        include: true,
      },
      contentLists: [
        { id: 'all-content', contentFilter: { type: ['category'] } },
      ],
      ...customBody,
    };

    const response = await window.voyadoApi.query.autocomplete(params, body);

    return response;
  }

  buildProductCards(productSuggestion) {
    const productData = productSuggestion.products[0];
    const voyadoProductCard = document.createElement('voyado-product-card');
    voyadoProductCard.productData = productData;
    return voyadoProductCard;
  }

  buildSearchResults(data) {
    const productSuggestions = data?.productSuggestions;
    const phraseSuggestions = data?.phraseSuggestions;
    const totalHits = data?.totalHits;
    const resultsContainer = document.createElement('div');
    const collectionSuggestions = data?.contentLists[0].items;
    resultsContainer.className = 'voyado-predictive-search__results-wrap';
    const productCards = productSuggestions.map((productSuggestion) => {
      return this.buildProductCards(productSuggestion);
    });

    resultsContainer.innerHTML = `
    <div class="voyado-predictive-search__results-wrap">
    ${
      phraseSuggestions.length > 0
        ? `
      <div>
        <p class="voyado-predictive-search__results-title">Suggestions</p>
        <div class="voyado-predictive-search__results-suggestions">
        ${phraseSuggestions
          .map((search) => {
            const highlightedContent = search.highlighted
              .replace('{', '<strong>')
              .replace('}', '</strong>');
            return `
          <a href="/search?q=${search.q}&origin=PHRASE_SUGGEST">${highlightedContent}</a>
          `;
          })
          .join('')}
        </div>
      </div>
      `
        : ''
    }
        ${
          collectionSuggestions.length > 0
            ? `
      <div>
        <p class="voyado-predictive-search__results-title">Collections</p>
        <div class="voyado-predictive-search__results-suggestions">
        ${collectionSuggestions
          .map((item) => {
            return `
          <a href="${item.link}" data-ticket="${item.ticket}">${item.title}</a>
          `;
          })
          .join('')}
        </div>
      </div>
      `
            : ''
        }
      <div>
        ${
          productCards.length > 0
            ? `
          <p class="voyado-predictive-search__results-title">Products</p>
        `
            : ''
        }
          <div class="voyado-predictive-search__results-products">
          </div>
      </div>
      <div>
        <a class="voyado-predictive-search__results-view-all" href="/search?q=${this.query}">View ${totalHits} ${totalHits === 1 ? 'Result' : 'Results'} for "${this.query}"</a>
      </div>
    </div>
    `;
    const productGrid = resultsContainer.querySelector(
      '.voyado-predictive-search__results-products',
    );
    productCards.forEach((productCard) => {
      productGrid.appendChild(productCard);
    });

    resultsContainer.addEventListener('click', (e) => {
      const ticketLink = e.target.closest('a[data-ticket]');
      if (!ticketLink) return;

      const ticket = ticketLink.dataset.ticket;
      if (!ticket) return;

      e.preventDefault();
      window.voyadoApi.notify
        .click(ticket)
        .finally(() => {
          window.location.href = ticketLink.href;
        });
    });

    return resultsContainer;
  }
}

class VoyadoSlider extends HTMLElement {
  constructor() {
    super();
    this.pageReference = null;
    this.limit = 24;
  }
  connectedCallback() {
    this.pageReference = this.getAttribute('page-reference') || '';
    this.limit = this.getAttribute('limit') || this.limit;
    if (this.pageReference === '') {
      console.error('voyado: page reference is required');
      return;
    }
    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    this.initSlider();
  }

  async getSliderData() {
    const params = {
      pageReference: this.pageReference,
      limit: this.limit,
    };
    const body = {};

    const response = await window.voyadoApi.query.landingPage(params, body);
    return response;
  }

  async initSlider() {
    const data = await this.getSliderData();
    const productGroups =
      data.recommendationLists?.[0]?.productGroups ||
      data.primaryList?.productGroups ||
      [];
    const sliderContainer = this.querySelector('.voyado-slider__container');
    const slider = document.createElement('div');
    slider.className = 'voyado-slider swiper';
    slider.innerHTML = `
    <div class="swiper-wrapper">
    </div>
    <div class="voyado-slider__controls">
      <div class="swiper-button-prev" aria-label="Previous slide"></div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next" aria-label="Next slide"></div>
    </div>
    `;
    const wrapper = slider.querySelector('.swiper-wrapper');

    productGroups.forEach((productGroup) => {
      const primaryProduct = productGroup.products[0];
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(new VoyadoProductCard(primaryProduct));
      wrapper.appendChild(slide);
    });

    sliderContainer.innerHTML = '';
    sliderContainer.appendChild(slider);

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
      },
    });

  }
}

class VoyadoFeatureGrid extends VoyadoSlider {
  constructor() {
    super();
    this.pageReference = null;
    this.limit = 4;
  }
  connectedCallback() {
    this.pageReference = this.getAttribute('page-reference') || '';
    if (this.pageReference === '') {
      console.error('voyado: page reference is required');
      return;
    }
    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    this.initFeatureGrid();
  }

  async initFeatureGrid() {
    const data = await this.getSliderData();
    const featureGridContainer = this.querySelector('.voyado-feature_grid');
    featureGridContainer.innerHTML = '';
    data.primaryList.productGroups.forEach((productGroup) => {
      const productCard = new VoyadoProductCard(productGroup.products[0]);
      featureGridContainer.appendChild(productCard);
    });
  }
}

class VoyadoRecommendations extends VoyadoSlider {
  constructor() {
    super();
    this.productId = null;
    this.limit = 16;
  }
  connectedCallback() {
    this.productId = this.getAttribute('product-id') || '';
    this.limit = this.getAttribute('limit') || this.limit;
    if (this.productId === '') {
      console.error('voyado: product id is required');
      return;
    }
    this.initRecommendations();
  }

  async initRecommendations() {
    const data = await this.getProductData();
    const productGroups =
      data?.recommendationLists[0]?.productGroups ||
      data?.primaryList?.productGroups;
    const sliderContainer = this.querySelector('.voyado-slider__container');
    const slider = document.createElement('div');
    slider.className = 'voyado-slider swiper';
    slider.innerHTML = `
    <div class="swiper-wrapper">
    </div>
    <div class="voyado-slider__controls">
      <div class="swiper-button-prev" aria-label="Previous slide"></div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next" aria-label="Next slide"></div>
    </div>
    `;
    const wrapper = slider.querySelector('.swiper-wrapper');

    productGroups.forEach((productGroup) => {
      const primaryProduct = productGroup.products[0];
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(new VoyadoProductCard(primaryProduct));
      wrapper.appendChild(slide);
    });

    sliderContainer.appendChild(slider);

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 16,
      slidesPerGroup: 1,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        500: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
      },
    });

  }

  async getProductData() {
    const params = {
      productKey: this.productId,
      limit: this.limit,
    };
    const body = {
      productGroup: {
        include: true,
      },
      recommendationLists: [
        {
          id: 'RECS1',
          algorithm: 'UPSELL',
          limit: this.limit,
          params: {
            productKey: this.productId,
          },
          visualization: 'CAROUSEL',
        },
      ],
    };

    const response = await window.voyadoApi.query.productPage(params, body);
    return response;
  }
}

customElements.define('voyado-accordion', VoyadoAccordion);
customElements.define('voyado-product-card', VoyadoProductCard);
customElements.define('voyado-product-grid', VoyadoProductGrid);
customElements.define('voyado-search', VoyadoSearch);
customElements.define('voyado-predictive-search', VoyadoPredictiveSearch);
customElements.define('voyado-slider', VoyadoSlider);
customElements.define('voyado-feature-grid', VoyadoFeatureGrid);
customElements.define('voyado-recommendations', VoyadoRecommendations);

window.addEventListener('DOMContentLoaded', async () => {
  const isProductPage = window.location.pathname.includes('/products/');
  if (!isProductPage) return;

  const addToCartButton = document.querySelector(
    'product-form form button[type="submit"]',
  );
  const productId = addToCartButton.getAttribute('product-id');

  const productData = await voyadoApi.query.productPage({
    productKey: productId,
  });

  const tickets = productData.tickets ?? {};
  const firstTicketKey = Object.keys(tickets)[0];
  voyadoTicket =
    firstTicketKey != null ? tickets[firstTicketKey] : undefined;

  addToCartButton.addEventListener('click', (e) => {
    if (voyadoTicket != null) {
      window.voyadoApi.notify.addToCart(voyadoTicket);
    }
  });
});
